import { carouselData } from '@/mocks/homeData';

const carouselImages = [
  'https://readdy.ai/api/search-image?query=Mysterious%20dark%20urban%20scene%20with%20dramatic%20lighting%2C%20noir%20atmosphere%20with%20warm%20orange%20and%20deep%20shadow%20contrast%2C%20manga%20inspired%20cityscape%20silhouette%2C%20cinematic%20composition%2C%20soft%20gradients%2C%20modern%20digital%20art&width=600&height=400&seq=carousel-1&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Romantic%20summer%20school%20scene%20with%20cherry%20blossoms%20in%20soft%20warm%20sunset%20light%2C%20anime%20style%20illustration%2C%20gentle%20pink%20and%20golden%20tones%2C%20youthful%20atmosphere%2C%20clean%20artistic%20composition&width=600&height=400&seq=carousel-2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Epic%20martial%20arts%20scene%20with%20dynamic%20sword%20action%20in%20ancient%20Chinese%20setting%2C%20dramatic%20warm%20golden%20and%20amber%20lighting%2C%20ink%20painting%20style%2C%20powerful%20composition&width=600&height=400&seq=carousel-3&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Fantasy%20portal%20to%20another%20world%20with%20magical%20glowing%20light%2C%20adventure%20themed%20illustration%20in%20warm%20orange%20and%20teal%20contrast%2C%20anime%20style%2C%20epic%20cinematic%20composition&width=600&height=400&seq=carousel-4&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Post%20apocalyptic%20survival%20scene%20with%20ruins%20in%20warm%20sunset%20light%2C%20sci%20fi%20manga%20aesthetic%2C%20dramatic%20sky%20with%20orange%20and%20amber%20clouds%2C%20cinematic%20composition&width=600&height=400&seq=carousel-5&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Ethereal%20fantasy%20forest%20scene%20with%20magical%20glowing%20elements%2C%20Chinese%20ink%20painting%20style%20with%20warm%20soft%20lighting%2C%20romantic%20atmosphere%2C%20delicate%20composition%2C%20fox%20spirit%20theme&width=600&height=400&seq=carousel-6&orientation=landscape',
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-4 whitespace-nowrap">
            焦点专题
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            热门漫画专题推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">编辑团队精选优质漫画，每一部都值得阅读</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselData.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-colors cursor-pointer group"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={carouselImages[i]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-[10px] font-medium bg-accent-500 text-white rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3">{item.desc}</p>
                <div className="flex items-center justify-between">
                  <span className="text-[10px] md:text-xs text-foreground-400 bg-background-100 px-2 py-1 rounded whitespace-nowrap">{item.genre}</span>
                  <span className="text-xs font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer">
                    查看详情 <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}